/**
 * Utilidades de cálculo de precios para órdenes con lista de precios.
 * Lógica pura sin dependencias React — testeable con PBT.
 */

/**
 * Calcula el precio ajustado aplicando un porcentaje de ajuste al precio base.
 * Fórmula: round(precioBase * (1 + porcentajeAjuste / 100), 2)
 *
 * @param precioBase - Precio original del examen
 * @param porcentajeAjuste - Porcentaje de ajuste (puede ser negativo para descuento)
 * @returns Precio ajustado redondeado a 2 decimales
 */
export function calcularPrecioAjustado(precioBase: number, porcentajeAjuste: number): number {
  return Math.round(precioBase * (1 + porcentajeAjuste / 100) * 100) / 100;
}

/**
 * Formatea la etiqueta de una lista de precios para mostrar en el selector.
 * Ejemplo: "Lista Corporativa (+15%)" o "Lista Descuento (-10%)"
 *
 * @param nombre - Nombre de la lista de precios
 * @param porcentaje - Porcentaje de ajuste
 * @returns Etiqueta formateada con nombre y porcentaje
 */
export function formatListaPrecioLabel(nombre: string, porcentaje: number): string {
  const signo = porcentaje >= 0 ? "+" : "";
  return `${nombre} (${signo}${porcentaje}%)`;
}
